import { render, staticRenderFns } from "./AboutLicensed.vue?vue&type=template&id=5b3dfd32&scoped=true"
import script from "./AboutLicensed.vue?vue&type=script&lang=js"
export * from "./AboutLicensed.vue?vue&type=script&lang=js"
import style0 from "./AboutLicensed.vue?vue&type=style&index=0&id=5b3dfd32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3dfd32",
  null
  
)

export default component.exports